(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["odict-for-you"] && !Shopify.designMode) return;
  try {
    
function initBestSellerCarousel() {
  document.querySelectorAll('#odict-for-you').forEach(section => {
    if (section.dataset.carouselReady) return;
    section.dataset.carouselReady = 'true';
    const track = section.querySelector('.odict-product-grid');
    const cards = Array.from(track.querySelectorAll('.odict-card'));
    const dots = Array.from(section.querySelectorAll('[data-carousel-dot]'));
    if (cards.length < 2) section.querySelector('.odict-carousel-dots').hidden = true;
    const update = () => {
      const box = track.getBoundingClientRect();
      const center = box.left + box.width / 2;
      let active = 0;
      let distance = Infinity;
      cards.forEach((card, i) => {
        const rect = card.getBoundingClientRect();
        const next = Math.abs(rect.left + rect.width / 2 - center);
        if (next < distance) { distance = next; active = i; }
      });
      dots.forEach((dot, i) => dot.setAttribute('aria-current', i === active ? 'true' : 'false'));
    };
    dots.forEach((dot, i) => dot.addEventListener('click', () => {
      cards[i].scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'nearest',inline:'center'});
    }));
    track.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update);
    update();
  });
}
initBestSellerCarousel();
document.addEventListener('shopify:section:load', initBestSellerCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odict-stores"]) return;
  try {
    
const feedback = document.querySelector('.odict-store-feedback__details');
if (feedback && (feedback.querySelector('[role="status"], [role="alert"]') || location.search.includes('contact_posted=true'))) feedback.open = true;

  } catch(e) { console.error(e); }
})();
})();
